import QuestionCircleIcon from '@atlaskit/icon/core/question-circle';
import * as React from 'react';

export function SvgHelpCircle() {
  return <QuestionCircleIcon label="" testId="ads-refreshed-icon" />;
}
